module.exports = __webpack_public_path__ + "static/media/Channel_icon.7996ca74.svg";